import noop from 'lodash/noop';

export const defaultProps = {
  showMetric: false,
  metric: {},
  enableDeleteIcon: false,
  selectable: false,
  selectableState: true,
  index: 0,
  selectCombinationFilterActionHandler: noop,
  deleteActionHandler: noop,
};
